module.exports = __webpack_public_path__ + "img/whatsapp.fa1f887a.svg";